import React, { useState, useEffect, useLayoutEffect } from 'react'
import { PC_WT_MAP, GENERAL_GREY, DUMMY } from '../../config/constants'
import { USER_READ_BOARD, REMOVE_BOARD, EDIT_BOARD_NAME, REMOVE_PI_FROM_BOARD } from '../../config/api'
import { iconwrapper, Retrieve_personal_info } from '../../config/commonfunctions';
import { Checkdevice } from '../../components/Checkdevice';
import { Projectcard, Headtitle, Modcfm, Portalmodal, ScreenWidth, ScreenHeight } from '../../components';
import axios from 'axios'
import { BOARD_ICON, DOTDOTDOT_ICON, TRASH_ICON } from '../../config/svgicons';
import { input_dom } from '../Main/Planning/Invitationmaker/components/Commonelements/Commonelements';
import './UserBoard.css'

const numFavbasedonvt = (item, width = 20, color = GENERAL_GREY) => { // number of favourite based on specific vendortype
    return <div style={{ width: width, color: color, fontSize: 10, display: 'flex', justifyContent: 'center', padding: '0px 15px 0px 5px' }}>
        {item}
    </div>

}
const numFirstchar = (item, width = 20) => {
    return <div style={{ width: width, color: GENERAL_GREY, fontSize: 10, padding: '0px 5px 0px 15px' }}>
        {item}
    </div>
}

function createDummyFavourite(num) {
    let result = []
    const imgs = [
        'https://images.unsplash.com/photo-1602629106916-db7c94b71e8b?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        'https://images.unsplash.com/photo-1596744743274-47100a0ecb3c?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        'https://images.unsplash.com/photo-1777917674925-61145b1d681a?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        'https://images.unsplash.com/photo-1760462488320-ec9512f924bd?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        'https://images.unsplash.com/photo-1554793423-98fa9cc9001e?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        'https://images.unsplash.com/photo-1777487590282-affcfffb984d?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        'https://images.unsplash.com/photo-1734594981986-4163b2033bb7?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        'https://images.unsplash.com/photo-1775126964228-6aef715141b8?q=80&w=1036&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        'https://images.unsplash.com/photo-1680515221135-6031a0f0173c?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        'https://images.unsplash.com/photo-1602629107341-6f8f0f8fa552?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    ]

    const profileimgs = [
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2",
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
        "https://images.unsplash.com/photo-1524504388940-b1c1722653e1",
        "https://images.unsplash.com/photo-1552058544-f2b08422138a",
        "https://images.unsplash.com/photo-1547425260-76bcadfb4f2c",
        "https://images.unsplash.com/photo-1517841905240-472988babdf9",
        "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6",
        "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e",
        "https://images.unsplash.com/photo-1527980965255-d3b416303d12"
      ]

    const displaynames = [  "Lumen & Frame Studio",  "Aperture & Atlas Photography",  "Eclipse Visuals",  "Shutterly Co.",  "Vanta Lens Studio",  "Pixelloom Photography",  "Quiet Light Studio",  "Golden Drift Photography",  "Stillwave Visuals",  "Everframe Moments"]
    
    const names = [  "Ever After Moments",  "The Vow Project",  "Happily Ever Capture",  "Golden Union Weddings",  "Once & Always Studio",  "Promise Lane Weddings",  "The Knot Collective",  "Forever Frame Weddings",  "Love Story Atelier",  "Union & Light Project"]

    for (let i = 0; i < num; i++) {
        result.push({
            displayname: displaynames[i],
            creator_profileimg_id: {
                bg: "",
                link: profileimgs[i]

            },
            name: names[i],
            selectedimg_extlinks:[imgs[i]],
            selectedimg_pattern:2,
            vendortype:"Photographers",
            dummy:true // refer this as dummy data
        })
    }
    return result
}

const portalmidcss_web = {
    width: 600,
    height: 660,
    top: 'calc( 50% - 330px )',
    backgroundColor: 'white',
    left: 0, right: 0,
    margin: 'auto',
    transform: 'none',
}

const portalmidcss_mobile = {
    width: '100%',
    height: '100%',
    top: 0,
    backgroundColor: 'white',
    left: 0, right: 0,
    margin: 'auto',
    transform: 'none'
}

const portalmidcsswtlarger_mobile = {
    width: '100%',
    height: '100%',
    top: 0,
    backgroundColor: 'white',
    left: 0, right: 0,
    margin: 'auto',
    transform: 'none',
    overflowX: 'scroll'
}

export default function UserBoard(props) {

    const { token, _id, acct_type } = Retrieve_personal_info()

    // basic data
    const [board_ids, setBoard_ids] = useState([])
    const [favourite_pi_ids, setFavourite_pi_ids] = useState([])

    // action
    const [selectedboardname, setSelectedoardname] = useState('All Projects')
    const [selectedboard, setSelectedboard] = useState(0)

    // for delete a project card
    const [deleteprojectdialog, setDeleteprojectdialog] = useState(false)

    // for delete board
    const [deleteboarddialog, setDeleteboarddialog] = useState(false)

    // use in board and project card
    const [deletedata, setDeletedata] = useState({})

    // for edit name board
    const [editboardname, setEditboardname] = useState('')
    const [editboarddialog, setEditboarddialog] = useState(false)

    // mobile
    const [mobiledialog, setMobiledialog] = useState(false)

    const [openMenuId, setOpenMenuId] = useState(null);
    const [threedotpopup, setThreedotpopup] = useState(false)
    const [threedotpopupid, setThreedotpopupid] = useState('')

    useEffect(() => {
        const handleClickOutside = () => setOpenMenuId(null);
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    const device = Checkdevice()
    const screen_width = ScreenWidth()
    const screen_height = ScreenHeight()

    useEffect(() => {
        init()
    }, [])

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [selectedboard])

    useLayoutEffect(() => {
        if (device === 'MOBILE' && mobiledialog) {
            //get original value of body
            const originalStyle = window.getComputedStyle(document.body).overflow;
            //prevent scrolling on mount
            document.body.style.overflow = "hidden";
            // re-enable scrolling when component unmounts
            return () => (document.body.style.overflow = originalStyle);
        }
    }, [mobiledialog]); //empty array to ensures effect is only run when mount and unmount

    function init() {
        let options = {
            method: 'POST',
            url: USER_READ_BOARD,
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
            data: { _id, acct_type }
        }
        axios(options).then((result) => {
            const { status } = result
            if (status === 200) {
                var { board_ids, favourite_pi_ids } = result.data.data

                var active_pids = favourite_pi_ids.map(({ _id }) => { return _id })

                // check if vendor deleted the project or not
                for (let x = 0; x < board_ids.length; x++) {
                    const { pi_ids } = board_ids[x]
                    for (let y = 0; y < pi_ids.length; y++) {
                        if (!active_pids.includes(pi_ids[y])) {
                            // add blank pid to each 'board' 
                            var inactive_pid = pi_ids[y]
                            favourite_pi_ids.push({ _id: inactive_pid, creator_profileimg_id: { link: '' } })
                        }
                    }
                }

                board_ids.unshift({ name: 'All Projects', pi_ids: favourite_pi_ids }) // push to the front 
                setBoard_ids(board_ids)
                
                if(DUMMY){
                    let dummy_favourite_pi_ids = createDummyFavourite(9)
                    setFavourite_pi_ids([...favourite_pi_ids, ...dummy_favourite_pi_ids])
                }
                else{
                    setFavourite_pi_ids([...favourite_pi_ids])
                }                
            }
        })
    }

    const sidebar_old = <div id='Userboard_sidebar' style={{ borderRight: '1px solid var(--lightdark)' }}>
        {board_ids.map(({ name, pi_ids, _id }, i) => {
            const len = pi_ids.length
            return <button
                key={_id + '_' + i}
                className={'Favouritevendor_vt'}
                onClick={() => {
                    setSelectedboard(i);
                    setSelectedoardname(name);
                }}
                style={{
                    borderRight: 'none'
                }}
            >
                {numFirstchar('', 30)}
                <div className={`Favouritevendor_readablevttxt Favouritevendor_readablevt${selectedboard === i ? 'selected' : ''}`}>
                    {name}
                </div>
                {numFavbasedonvt(len, 40)}
            </button>
        })}
    </div>


    const sidebar = <div id='Userboard_sidebar' style={{ borderRight: '1px solid var(--lightdark)' }}>

        <div className='Favouritevendor_sidebartxt'>
            <div style={{ backgroundColor: 'var(--cornerpink)', width: 35, height: 35, display: 'flex', placeItems: 'center', placeContent: 'center', borderRadius: 100 }}>
                {iconwrapper(BOARD_ICON, { width: 20, height: 20, display: 'flex', placeContent: 'center', placeContent: 'center' })}
            </div>
            <div>Your Mood Board</div>
        </div>
        {board_ids.map(({ name, pi_ids, _id }, i) => {

            const numFavbasedonvt = (item, width = 20, color = GENERAL_GREY) => { // number of favourite based on specific vendortype
                return <div style={{ width: width, color: color, fontSize: 10, display: 'flex', justifyContent: 'center', padding: '0px 15px 0px 5px' }}>
                    {item}
                </div>

            }

            const len = pi_ids.length
            return <button
                key={_id + '_' + i}
                className={`Favouritevendor_vt Favouritevendor_readablevt${selectedboard === i ? 'selected' : ''}`}
                onClick={() => {
                    setSelectedboard(i);
                    setSelectedoardname(name);
                }}
                style={{
                    borderRight: 'none'
                }}
            >
                <div className={`Favouritevendor_readablevttxt`} style={{ marginLeft: 20 }}>
                    {name}
                </div>
                {numFavbasedonvt(len, 40)}
            </button>
        })}
    </div>


    const maincontent = <div id='Favouritevendor_maincontent'>

        <div id='Favouritevendor_viewmoreroot' style={{ borderBottom: '1px solid var(--lightdark)' }}>

            {/* <button id='Userboard_viewmorevendorbtn'>View More Projects</button>
            <button id='Userboard_viewmorevendorbtn'>Analytics</button> */}


            {selectedboard === 0
                ? null
                : <button id='Favouritevendor_viewmorevendorbtn' onClick={() => { setEditboarddialog(true); setEditboardname(selectedboardname); }}>
                    <div className='Favouritevendor_selectedvttitle'>
                        <div>Edit</div>
                        <div>Board</div>
                    </div>
                </button>}


            {selectedboard === 0
                ? null
                : <button id='Favouritevendor_viewmorevendorbtn' onClick={() => { setDeleteboarddialog(true) }}>
                    <div className='Favouritevendor_selectedvttitle'>
                        <div>Delete</div>
                        <div>Board</div>
                    </div>
                </button>}

        </div>

        <div id='Userboard_grid'>

            {favourite_pi_ids.map((item, index) => {
                var pcwt
                if (device === 'MOBILE') {
                    pcwt = PC_WT_MAP['MOBILE']
                }
                else if (device === 'TABLET') {
                    pcwt = PC_WT_MAP['TABLET']
                }
                else {
                    pcwt = PC_WT_MAP['WEB']
                }



                const ICON_CSS = { width: 15, height: 15, backgroundColor: 'white', display: 'flex', alignItems: 'center', placeContent: 'center', color: 'var(--maindark)' }
                const deletebtn = <button className='Userboard_trash' onClick={() => { setDeleteprojectdialog(true); setDeletedata({ _id: item._id }) }}>{iconwrapper(TRASH_ICON, ICON_CSS)}</button>

                const deleteitem = () => {
                    setDeleteprojectdialog(true);
                    setDeletedata({ _id: item._id })
                    setThreedotpopup(false)
                    setThreedotpopupid('')
                }

                if (selectedboard === 0) {
                    return <li className='Userboard_griditem' key={index + 'pc'} style={{ width: pcwt }}>
                        <Projectcard key={'Userboard_cardroot' + index} item={item} viewtype={1} device={device} />
                        <button className='Userboard_trash' onClick={() => { setThreedotpopup(true); setThreedotpopupid(item._id) }}>{iconwrapper(DOTDOTDOT_ICON, ICON_CSS)}</button>
                        {threedotpopup && threedotpopupid === item._id
                            ? <div className='Userboard_itempopup' onMouseLeave={() => { setTimeout(() => { setThreedotpopup(false); setThreedotpopupid('') }, 1000) }}>
                                <button className='Userboard_deletebtn' onClick={deleteitem}>{iconwrapper(TRASH_ICON, ICON_CSS)} Delete</button>
                            </div>
                            : null}
                    </li>
                }
                else {
                    const projid = item._id
                    if (board_ids[selectedboard].pi_ids.includes(projid)) {
                        return <li key={index + 'pc'} style={{ width: pcwt, position: 'relative', listStyleType: 'none', display: 'flex', justifyContent: 'center', margin: '0px 5px' }}>
                            <Projectcard key={'Userboard_cardroot' + index} item={item} viewtype={1} device={device} />
                            {deletebtn}
                        </li>
                    }
                }
            })}



        </div>

    </div>

    const deleteprojectcardcfm = deleteprojectdialog
        ? <Modcfm
            onHide={() => { setDeleteprojectdialog(false) }}
            onOk={() => {
                if (deleteprojectdialog) {
                    axios({
                        method: 'POST',
                        url: REMOVE_PI_FROM_BOARD,
                        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
                        data: { _id: _id, projectinterface_id: deletedata._id, }
                    }).then((res) => {
                        const { message } = res.data
                        if (message === 'SUCCESS') {
                            init()
                            setDeletedata({})
                        }
                    }).catch((e) => {
                        console.log(e)
                    })
                }
            }}
            onNo={() => { setDeleteprojectdialog(false) }}
            txt={'Delete Project. Please be certain.'}
        />
        : null

    const deleteboardcfm = deleteboarddialog
        ? <Modcfm
            onHide={() => { setDeleteboarddialog(false) }}
            onOk={() => {
                if (deleteboarddialog) {
                    axios({
                        method: 'POST',
                        url: REMOVE_BOARD,
                        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
                        data: { _id, board_id: board_ids[selectedboard]._id, selectedboardname, pi_ids: board_ids[selectedboard].pi_ids }
                    }).then((res) => {
                        const { message } = res.data
                        if (message === 'SUCCESS') {
                            setEditboardname(false)
                            setSelectedboard(0)
                            setSelectedoardname('All Projects')
                            setDeleteboarddialog(false)
                            setDeletedata({})
                            init()
                        }
                    }).catch((e) => {
                        console.log(e)
                    })
                }
            }}
            onNo={() => { setDeleteboarddialog(false) }}
            txt={'Delete Board. Please be certain.'}
        />
        : null


    const editboardmodal = <Portalmodal
        portaltype={'commonportal'}
        open={editboarddialog}
        onClose={() => {
            setEditboarddialog(false)
        }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={(device === 'WEB' || device === 'TABLET') ? portalmidcss_web : screen_width > screen_height ? portalmidcsswtlarger_mobile : portalmidcss_mobile}
        closestyle={{ right: 0 }}
        floatingclosecolor='var(--maindark)'
    >

        <div className='Portalmodal_vtroot'>
            {input_dom(
                'Board Name',
                'Board Name',
                editboardname,
                (e) => {
                    if (e.target.value.length < 50) {
                        setEditboardname(e.target.value)
                    }
                },
                'boardname_id',
                {},
                false,
                null,
                {},
                { margin: 0, width: '100%', padding: '0px 10px' }
            )}
            <div style={{ width: '100%', display: 'flex', placeContent: 'flex-end', padding: 10 }}>
                <button
                    className='rrequests_sendbtn'
                    onClick={() => {
                        axios({
                            method: 'POST',
                            url: EDIT_BOARD_NAME,
                            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
                            data: { _id, board_id: board_ids[selectedboard]._id, selectedboardname, new_name: editboardname }
                        }).then((res) => {
                            const { message } = res.data
                            if (message === 'SUCCESS') {
                                // init()
                                let new_board_ids = JSON.parse(JSON.stringify(board_ids))
                                new_board_ids[selectedboard].name = editboardname
                                setBoard_ids(new_board_ids)
                                setEditboardname('')
                                setSelectedoardname(editboardname)
                                setEditboarddialog(false)
                            }
                        }).catch((e) => {
                            console.log(e)
                        })
                    }}>
                    Update
                </button>
            </div>
        </div>
    </Portalmodal>


    const WEB_TABLET_DOM = <div
        className='Favouritevendor_row'
        //  style={{ height: 'calc( 100% - 35px - 85px )' }}
        style={{ height: '100%' }}
    >
        {sidebar}
        {maincontent}

    </div>

    const MOBILE_DOM = <div className='Userboard_col'>
        {favourite_pi_ids.map((item, index) => {
            var pcwt
            if (device === 'MOBILE') {
                pcwt = PC_WT_MAP['MOBILE']
            }
            else if (device === 'TABLET') {
                pcwt = PC_WT_MAP['TABLET']
            }
            else {
                pcwt = PC_WT_MAP['WEB']
            }

            const ICON_CSS = { width: 15, height: 15, backgroundColor: 'white', display: 'flex', alignItems: 'center', placeContent: 'center', color: 'var(--mainpink)' }
            const deletebtn = <button className='Userboard_trash' onClick={() => { setDeleteprojectdialog(true); setDeletedata({ _id: item._id }) }}>{iconwrapper(TRASH_ICON, ICON_CSS)}</button>

            if (selectedboard === 0) {
                return <li key={index + 'pc'} style={{ width: pcwt, position: 'relative', listStyleType: 'none', display: 'flex', justifyContent: 'center', margin: '0px 5px' }}>
                    <Projectcard key={'Userboard_cardroot' + index} item={item} viewtype={1} device={device} />
                    {deletebtn}
                </li>
            }
            else {
                const projid = item._id
                if (board_ids[selectedboard].pi_ids.includes(projid)) {
                    return <li key={index + 'pc'} style={{ width: pcwt, position: 'relative', listStyleType: 'none', display: 'flex', justifyContent: 'center', margin: '0px 5px' }}>
                        <Projectcard key={'Userboard_cardroot' + index} item={item} viewtype={1} device={device} />
                        {deletebtn}
                    </li>
                }
            }
        })}
    </div>

    const MOBILE_BOARDSELECTION = device === 'MOBILE'
        ? <div className='Userboard_mobileboardselectionroot' >
            {board_ids.map(({ name, pi_ids, _id }, i) => {
                const len = pi_ids.length
                return <button
                    key={_id + '_' + i}
                    className={'Favouritevendor_vt'}
                    onClick={() => {
                        setSelectedboard(i);
                        setSelectedoardname(name);
                    }}
                    style={{
                        borderRight: 'none',
                        fontSize: 12,
                        ...(i === selectedboard ? { backgroundColor: 'var(--cornerpink)', color: 'var(--maindark)' } : { backgroundColor: '#fff', color: 'var(--maindark)' })

                    }}
                >
                    {numFirstchar('', 30)}
                    <div>{name}</div>
                    {numFavbasedonvt(len, 40, i === selectedboard ? 'var(--maindark)' : GENERAL_GREY)}
                </button>
            })}
        </div>
        : null

    const MOBILE_PROJECUTILITY_old = device === 'MOBILE' && selectedboard !== 0
        ? <div id='Userboard_viewmoreroot' style={{ placeContent: 'flex-end', paddingRight: 5 }}>
            {selectedboard > 0 ? <button id='Userboard_viewmorevendorbtn' onClick={() => { setEditboarddialog(true); setEditboardname(selectedboardname); }}>Edit Board</button> : null}
            {/* <button id='Userboard_viewmorevendorbtn'>View More Projects</button>
            <button id='Userboard_viewmorevendorbtn'>Analytics</button> */}
            {selectedboard === 0 ? null : <button id='Userboard_viewmorevendorbtn' onClick={() => setDeleteboarddialog(true)}>Delete Board</button>}
        </div>
        : null


    const MOBILE_PROJECUTILITY = device === 'MOBILE' && selectedboard !== 0
        ? <div id='Favouritevendor_maincontent' style={{ placeContent: 'flex-end', paddingRight: 5, }}>
            <div id='Favouritevendor_viewmoreroot' style={{ borderBottom: '' }} >
                {selectedboard > 0
                    ? <button id='Favouritevendor_viewmorevendorbtn' onClick={() => { setEditboarddialog(true); setEditboardname(selectedboardname); }}>
                        <div className='Favouritevendor_selectedvttitle'>
                            <div>Edit</div>
                            <div>Board</div>
                        </div>
                    </button>
                    : null}

                {selectedboard === 0
                    ? null
                    : <button id='Favouritevendor_viewmorevendorbtn' onClick={() => { setDeleteboarddialog(true) }}>
                        <div className='Favouritevendor_selectedvttitle'>
                            <div>Delete</div>
                            <div>Board</div>
                        </div>
                    </button>}
            </div>
        </div>
        : null


    return <div id="Userboard_root">
        <Headtitle name="Board" color="var(--maindark)" />

        {{
            'WEB': WEB_TABLET_DOM,
            'TABLET': WEB_TABLET_DOM,
            'MOBILE': <>
                <div style={{ display: 'flex', flexDirection: 'row', placeItems: 'center', textAlign: 'center', gap: 5, padding: 5 }}>
                    <div style={{ backgroundColor: 'var(--cornerpink)', width: 30, height: 30, display: 'flex', placeItems: 'center', placeContent: 'center', borderRadius: 100 }}>
                        {iconwrapper(BOARD_ICON, { width: 15, height: 15, display: 'flex', placeContent: 'center', placeContent: 'center' })}
                    </div>
                    <div style={{ fontWeight: 'bold', fontSize: 16, }}>Your Mood Board</div>
                </div>
                {MOBILE_BOARDSELECTION}
                {MOBILE_PROJECUTILITY}
                {MOBILE_DOM}
            </>

        }[device]}

        {deleteprojectcardcfm}
        {deleteboardcfm}
        {editboardmodal}
    </div>

}
